import { InputHTMLAttributes } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";
import { ErrorText } from "../../errors/ErrorText";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClassname?: string;
  register?: UseFormRegister<any>;
  registerOpt?: any;
  errorText?: string;
}

export const CustomInput: React.FC<Props> = (props) => {
  const {
    labelClassname,
    label,
    register,
    registerOpt = {},
    className: inputClassName,
    ...inputProps
  } = props;

  return (
    <div className="custom-input">
      {label && (
        <label htmlFor={inputProps.id} className={labelClassname}>
          {label}
          {inputProps.required && <span className="text-danger"> *</span>}
        </label>
      )}

      {register && inputProps?.name ? (
        <input
          className={`form-control ${inputClassName}`}
          {...register(inputProps.name, registerOpt)}
          {...inputProps}
        />
      ) : (
        <input className={`form-control ${inputClassName}`} {...inputProps} />
      )}

      <ErrorText error={props.errorText} className="text-danger" />
    </div>
  );
};
